import { useSelector } from "react-redux";

export const useHubs = () => {
  const { userDetails } = useSelector((state) => state.loggedInUser);
  const { allHubs } = useSelector((state) => state.locations);

  let hubs = [];

  if (userDetails?.hubs?.length) {
    hubs = allHubs
      ?.filter((hub) => userDetails.hubs.includes(hub.id))
      ?.map((item) => ({ ...item, value: item.name }));
  }

  return hubs;
};
